import React from 'react';
import {List, Divider, Table, Collapse} from 'antd';

interface ExportData {
    system: SystemDto;
    name: string;
    description: string;
    id: number;
}

interface SystemDto {
    name: string
}

interface Props {
    exportDataList: ExportData[] | null | undefined;
}

const GroupedListSystem: React.FC<Props> = ({ exportDataList }) => {
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Beschreibung',
            dataIndex: 'description',
            key: 'description',
        },
    ];


    // Schritt 1: Tests nach 'system' gruppieren
    let systems: Record<string, ExportData[]> = {};

    if (Array.isArray(exportDataList)) {
        exportDataList.forEach(exportData => {
            if (!systems[exportData.system.name]) {
                systems[exportData.system.name] = []; // Initialisiere das Array für das System
            }
            systems[exportData.system.name].push(exportData); // Füge den Test zum entsprechenden System hinzu
        });
    }

    return (
        <Collapse accordion>
            {Object.entries(systems).map(([system, items]) => (
                <Collapse.Panel key={system} header={`${String(system)} (${items.length})`}>
                    <Table
                        style={{ marginTop: '5px' }}
                        bordered
                        columns={columns}
                        dataSource={items.map((item, index) => ({ ...item, key: index }))}
                        pagination={false}
                    />
                </Collapse.Panel>
            ))}
        </Collapse>
    );
};

export default GroupedListSystem;
